import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { Children, cloneElement } from "react";
import { rem } from "./auth-service-tools172.js";
import { getRadius } from "./auth-service-tools185.js";
import { createVarsResolver } from "./auth-service-tools191.js";
import { getThemeColor } from "./auth-service-tools208.js";
import { getContrastColor } from "./auth-service-tools214.js";
import { getAutoContrastValue } from "./auth-service-tools215.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { Box } from "./auth-service-tools244.js";
import { factory } from "./auth-service-tools248.js";
import { TimelineProvider } from "./auth-service-tools421.js";
import { TimelineItem } from "./auth-service-tools422.js";
import classes from "./auth-service-tools423.js";
const defaultProps = {
  active: -1,
  align: "left",
  reverseActive: false
};
const varsResolver = createVarsResolver((theme, _ref) => {
  let {
    bulletSize,
    lineWidth,
    radius,
    color,
    autoContrast
  } = _ref;
  return {
    root: {
      "--tl-bullet-size": rem(bulletSize),
      "--tl-line-width": rem(lineWidth),
      "--tl-radius": radius === void 0 ? void 0 : getRadius(radius),
      "--tl-color": color ? getThemeColor(color, theme) : void 0,
      "--tl-icon-color": getAutoContrastValue(autoContrast, theme) ? getContrastColor({
        color,
        theme,
        autoContrast
      }) : void 0
    }
  };
});
const Timeline = factory((_props, ref) => {
  const props = useProps("Timeline", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    children,
    active,
    color,
    radius,
    bulletSize,
    align,
    lineWidth,
    reverseActive,
    mod,
    autoContrast,
    ...others
  } = props;
  const getStyles = useStyles({
    name: "Timeline",
    classes,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver
  });

  const _children = Children.toArray(children);

  const items = _children.map((item, index) => {
    var _a, _b;

    return /*#__PURE__*/cloneElement(item, {
      unstyled,
      __align: align,
      __active: ((_a = item.props) == null ? void 0 : _a.active) || (reverseActive ? active >= _children.length - index - 1 : active >= index),
      __lineActive: ((_b = item.props) == null ? void 0 : _b.lineActive) || (reverseActive ? active >= _children.length - index - 1 : active - 1 >= index)
    });
  });

  return /* @__PURE__ */jsxRuntimeExports.jsx(TimelineProvider, {
    value: {
      getStyles
    },
    children: /* @__PURE__ */jsxRuntimeExports.jsx(Box, { ...getStyles("root"),
      mod: [{
        align
      }, mod],
      ref,
      ...others,
      children: items
    })
  });
});
Timeline.classes = classes;
Timeline.displayName = "@mantine/core/Timeline";
Timeline.Item = TimelineItem;
export { Timeline };